import * as React from "react";
import {FlashReportSummary} from "../../../model/FlashReportSummary.model";
import {TrackedLink} from "../../base/TrackedLink.component";
import {formatShortDate} from "../../../utils/dateUtil";
import {UserBehaviorTrackerApi} from "../../../api/UserBehaviorTrackerApi";
import {getBrowserLocationPath} from "../../../api/BrowserWrapper";

export interface IFlashReportListingProps {
    flashReport: FlashReportSummary;
}

export const FLASH_REPORT_PATH = "/flash-reports/";

export const FlashReportListing: React.FunctionComponent<IFlashReportListingProps> = (props) => {
    const path = getBrowserLocationPath() + FLASH_REPORT_PATH + props.flashReport.backstopId;
    const trackUserBehavior = () => { UserBehaviorTrackerApi.trackUserBehavior(path);};

    return <div className="__flash-report" key={`flash-report-${props.flashReport.backstopId}`}
                data-testid="flash-report">
            <div className="icon flash-report__icon fa-light fa-bell" />
            <div>
                <div onClick={() => trackUserBehavior()}>
                    <TrackedLink to={FLASH_REPORT_PATH + props.flashReport.backstopId}
                                 className="link-14"
                                 gaCategory=""
                                 gaAction="Link"
                                 gaLabel="">
                        {props.flashReport.title}
                    </TrackedLink>
                </div>
                <div className="flash-report__date date-12">{formatShortDate(props.flashReport.date)}</div>
            </div>
        </div>;
};